import React, {Fragment} from 'react';
import styles from '../../styles/modules/common/features.module.scss'
import { getStaticPath } from '../../utils';
import parse from 'html-react-parser'
import Image from '../common/Image'
interface Props {
    featureTitle?: string,
    featureText: string,
    featureImage: string,
    withFeatureTitle: boolean,
    length: number,
    index:any,
    isRoundShape?: boolean,
    imageSizeClass?: string,
    scrollToTop?: boolean,
}



const FeatureImageItem = (props: Props) =>{
    const {featureTitle, featureText, featureImage, withFeatureTitle, length} = props
    const scrollToTop = (event) => {
        event.preventDefault()
        const c_scroll = window.pageYOffset;
        if(c_scroll >= 1) {
            const element = document.getElementById("plan-selection")
            if(element) {
                let offsetPosition  = element.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                  });
            } else {
                window.scroll({
                    behavior: 'smooth',
                    left:0,
                    top: 0
                });
            }
        }
    }
    return (
        <Fragment>
            <div className={`col-12 col-sm-6 col-md-6 ${length >=4  ? 'col-lg-3' : 'col-lg-4'} ${styles.feature_item} ${styles.feature_item__singel_row}`}>
                {props.isRoundShape ? (<div onClick={(e:any) => { props.scrollToTop && scrollToTop(e)}} className={props.imageSizeClass ? `${styles.round_circle} ${props.imageSizeClass}` :  `${styles.round_circle}`}>
                    <div className={`${styles.feature_item__image} ${styles.feature_item__image__single_row}`}>
                        <Image src={getStaticPath(featureImage)} width="100%" height="100%" layout="responsive" objectFit="contain" />
                    </div>
                    </div>) : 
                    (
                        <div className={`${styles.feature_item__image} ${styles.feature_item__image__single_row}`}>
                        <Image src={getStaticPath(featureImage)} width="100%" height="100%" layout="responsive" objectFit="contain" />
                    </div>
                    ) }
                <div className={withFeatureTitle ? ` ${styles.feature_item__text} ${styles.feature_item__subtext}` : ` ${styles.feature_item__text}  ${styles.feature_item__nofeature}`}>
                    {withFeatureTitle &&
                        <div className={`${styles.feature_item__title}`}>
                            <p className="level-one">{featureTitle}</p>
                        </div>}
                    <p className={withFeatureTitle ? `${styles.line_break} ${styles.sub_text_width} level-two` :`${styles.line_break} ${styles.sub_text_width} level-one`}>{parse(featureText)}</p>
                </div>
            </div>
        </Fragment>
    )
}

export default FeatureImageItem
